import { gql, useMutation } from '@apollo/client';

import type {
  VerifyPhoneNumberMutation,
  VerifyPhoneNumberMutationVariables,
} from './__generated__/useVerifyPhoneNumber.gql';

const VERIFY_PHONE_NUMBER = gql`
  mutation VerifyPhoneNumber($input: VerifyPhoneNumberInput!) {
    verifyPhoneNumber(input: $input) {
      id
      phoneNumber
      phoneNumberVerifiedAt
    }
  }
`;

// Alert-surface refresh (verification resolves the unverified-phone alert) is
// handled centrally in ApolloProvider's mutation update — see
// `handleVerifyPhoneNumber`.
export const useVerifyPhoneNumber = () => {
  return useMutation<VerifyPhoneNumberMutation, VerifyPhoneNumberMutationVariables>(VERIFY_PHONE_NUMBER);
};
